import { createFileRoute } from '@tanstack/react-router';
import { useMe } from '../../api/me.ts';
import { ExportsPage } from '../../features/exports/exports-page.tsx';
import { guardSection } from '../../shell/guard.ts';

// Tracker-layout export (spec J8): each role downloads its own edition.
export const Route = createFileRoute('/_authed/exports')({
  beforeLoad: guardSection('/exports'),
  component: ExportsRoute,
});

function ExportsRoute(): React.JSX.Element {
  return <ExportsPage me={useMe()} />;
}
